// Angular
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';

// Services
import { EventsService } from 'src/app/services/events/events.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessagesService } from 'src/app/services/message/messages.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { BaseModalComponent } from 'src/app/shared/modals/base-modal/base-modal.component';

// Other
import Tabulator from 'tabulator-tables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WHAT } from 'src/app/shared/classes';
import { Subscription } from 'rxjs';

declare var moment: any;


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.less']
})
export class UsersComponent implements OnInit, AfterViewInit, OnDestroy {
  private table: Tabulator;
  private tableSubscription: Subscription;
  private filterStateObj = {
    currentFilter: '',
    allData: [],
    currentData: []
  };
  public list:any = [];
  public dateSelect:any = "";
  public years: number[] = [];
  constructor(private admin: AdminService, private ngbModal: NgbModal, private events: EventsService, private load: NgxSpinnerService,
    private msg: MessagesService) { }

  ngOnInit() {
    this.load.show();
    this.initTable();
    this.getUsers();
  }

  ngAfterViewInit() {
    this.listenToLoadTable();
  }

  ngOnDestroy() {
    this.exitPage();
  }

  // init page exit
  private exitPage() {
    this.tableSubscription.unsubscribe();
  }

  // listens to true values so that table can be reloaded with page reload
  private listenToLoadTable() {
    this.tableSubscription = this.events.getTableTriggers()
      .subscribe(triggers => {
        const from = triggers.from;
        switch (triggers.task) {
          case 'update':
            if (from === 'users') {
              if (triggers.userid && triggers.tableReload) {
                const userid = triggers.userid;
                const userData = triggers.userData as any;
                const firstName = userData.first_name;
                const lastName = userData.last_name;
                const fullName = firstName + ' ' + lastName;
                const email = userData.email;
                const accountType = userData.account_type;

                this.table.updateData([{ userid: userid, fname: firstName, lname: lastName, name: fullName, email: email, account_type: accountType }])
                  .then(() => {
                    // update table data state
                    this.filterStateObj.allData = this.table.getData();
                    // run code after data has been updated
                    this.load.hide();
                  })
                  .catch((error) => {
                    // handle error updating data
                    this.load.hide();
                  });
              }
            }

            break;
          case 'delete':
            if (from === 'users') {
              if (triggers.userid && triggers.tableReload) {
                const userid = triggers.userid;
                this.table.deleteRow(userid)
                  .then(() => {
                    // update table data state
                    this.filterStateObj.allData = this.table.getData();

                    // run code after data has been updated
                    this.load.hide();
                  })
                  .catch((error) => {
                    // handle error updating data
                    this.load.hide();
                  });
              }
            }
            break;
        }
      }, error => {
        console.log(error);
      });
  }

  // inits the table
  private initTable() {
    this.generateYearList();
    this.table = new Tabulator('#usersTable', {
      responsiveLayout: 'collapse',
      pagination: 'local',
      paginationSize: 15,
      paginationSizeSelector: true,
      index: 'userid',
      layout: 'fitColumns',
      columns: [
        { title: 'Name', field: 'name', sorter: 'string' },
        { title: 'User Id', field: 'user_id', width: 100, sorter: 'string' },
        { title: 'Admin Id', field: 'admin_id', width: 100, sorter: 'string' },
        { title: 'Company', field: 'company', width: 100, sorter: 'string' },
        { title: 'Country', field: 'country', width: 120, sorter: 'string' },
        { title: 'Account Type', field: 'account_type', width: 100, sorter: 'string' },
        { title:'Trial',field:'trial',width:100,sorter:'boolean'},
        { title: 'Email', field: 'email', width: 150, sorter: 'string' },
        {
          title: 'Register Date', field: 'date', sorter: 'date', sorterParams: {
            format: 'MMMM D YYYY, h:mm:ss A'
         }
        },
        {
          title: 'Expired Date', field: 'expired_date', sorter: 'date', sorterParams: {
            format: 'MMMM D YYYY, h:mm:ss A'
         }
        }
      ],
      rowClick: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'users',
          data: data
        };

        // mouse click event
        this.loadModal(newData);
      },
      rowTap: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'users',
          data: data
        };

        // touch screen tap
        this.loadModal(newData);
      }
    });
  }

  // get users all users
  private getUsers() {
    this.admin.GET(WHAT.Users)
      .then(res => this.success(res))
      .catch(err => this.error(err));
  }

  // search table
  public searchTable(searchValue) {
    const filters = [];
    const columns = this.table.getColumns();

    columns.forEach(function (column) {
      filters.push({
        field: column.getField(),
        type: 'like',
        value: searchValue,
      });
    });

    this.table.setFilter([filters]);
  }

  // open modal and pass user data to it
  private loadModal(data) {
    const userModal = this.ngbModal.open(BaseModalComponent, {
      size: 'lg'
    });

    userModal.componentInstance.data = data;

    // userModal
    userModal.result
      .then((msg) => {
        if (msg.success) {
          return;
        }
      })
      .catch((msg) => {
        console.log(msg);
      });
  }

  // handle success
  private success(res) {
    this.table.addData(res);
    // set all data
    this.filterStateObj.allData = this.table.getData();
    this.load.hide();
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }

  private generateYearList(){
    const currentYear = new Date().getFullYear();

    for (let year = currentYear; year >= 2017; year--) {
      this.years.push(year);
    }
  }
  // filter table based by selection
  public filterUserTable(filterValue) {
    this.table.clearFilter();
    this.table.replaceData(this.filterStateObj.allData);

    switch (filterValue) {
      case 'all':
        this.table.replaceData(this.filterStateObj.allData);
        break;
      case 'free':
        this.table.setFilter('account_type', '=', 'free');
        break;
      case 'beginner':
        this.table.setFilter(this.returnBeginnerPaid, '');
        break;
      case 'developer':
        this.table.setFilter(this.returnDeveloperPaid,'');
        break;
      case 'expired':
        this.table.setFilter('account_type', '=', 'expired');
       break;
      case 'suspend':
        this.table.setFilter('account_type', '=', 'Suspend');
        break;
    }

    this.setFilterState(filterValue);
  }

  // set the filter state
  private setFilterState(filterType) {
    this.filterStateObj.currentFilter = filterType;
    this.filterStateObj.currentData = this.table.getData(true);
    this.table.replaceData(this.filterStateObj.currentData);
  }

  // filters will reutrn beginners that paid not using via voucher
  public returnBeginnerPaid(data, filter) {
    const allBeginnerPaid = [];

    if (data.account_type === 'beginner' || data.account_type === 'Beginner' && data.hasOwnProperty('subscription') === true) {
      const subscription = JSON.parse(data.subscription);
      if (subscription !== null &&
        subscription.hasOwnProperty('account') === true) {
        allBeginnerPaid.push(data);
      }

      if (data.account_type === 'beginner' || data.account_type === 'Beginner' && data.subscription === null) {

        allBeginnerPaid.push(data);
      }
    }

    for (let i = 0; i < allBeginnerPaid.length; i++) {
      return allBeginnerPaid[i];
    }
  }

  public returnDeveloperPaid(data, filter) {
    const allDeveloperPaid = [];

    if (data.account_type === 'developer' && data.hasOwnProperty('subscription') === true) {
      const subscription = JSON.parse(data.subscription);
      if (subscription !== null &&
        subscription.hasOwnProperty('account') === true) {
         allDeveloperPaid.push(data);
      }
    }

    for (let i = 0; i < allDeveloperPaid.length; i++) {
      return allDeveloperPaid[i];
    }
  }

  // fitlers that will return beginners that got for free via vouchers
  public returnBeginnerFree(data, filterParams) {
    if (data.account_type === 'Beginner') {
      const subscription = JSON.parse(data.subscription);
      if (subscription !== null &&
        subscription.hasOwnProperty('account') === true &&
        subscription.account.hasOwnProperty('voucher_code') === true) {
        return data;
      }
    }
  }

  public setStart(value){
    this.reset();
    this.dateSelect = moment(value).format('MMMM D YYYY');
    this.filterbyDate();
  }

  public setYear(value){
    this.reset();
    if(value != 'all'){
      this.dateSelect = value;
      this.filterbyDate();
    }
  }

  public exportData(){
     this.table.download("csv","users.csv",{delimiter:","});
  }

  public reset(){
    this.table.clearFilter();
    this.table.replaceData(this.filterStateObj.allData);
    this.dateSelect = "";
 }

 private filterbyDate(){
      this.table.setFilter("date","like",this.dateSelect);
 }
}

